<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <BannerNotification />
    <ImageSlideUpdateHeader
      :title="instanceName"
      :componentName="componentName"
      :componentId="componentId"
      :instanceId="instanceId"
      :draftId="draftId"
      :handleUpdate="UpdateInstance"
      :handleUpdateDraft="handleUpdateDraft"
      :handleCreateDraft="handleCreateDraft"
      :handleCopy="CopyInstance"
      :formData="formData"
    />
    <ImageSlideUpdateForm
      class="p-4"
      :formData="formData"
      :instanceId="parseInt(instanceId)"
      :instanceData="instanceData"
      :allSlideAttrbutes="
        Object.keys(getSlideAttribute).length
          ? getSlideAttribute
          : getAllAttributes
      "
      @update:formData="handleUpdateFormData"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import ImageSlideUpdateHeader from "@/components/ComponentModule/ImageSlideComponent/ImageSlideUpdateHeader";
import ImageSlideUpdateForm from "@/components/ComponentModule/ImageSlideComponent/ImageSlideUpdateForm";

export default {
  name: "ImageSlideUpdatePage",
  components: {
    ImageSlideUpdateHeader,
    ImageSlideUpdateForm,
    BannerNotification
  },
  data() {
    return { formData: { hotspots: [] } };
  },
  props: {
    componentId: {
      type: String,
      required: true
    },
    instanceId: {
      type: String,
      required: true
    }
  },
  async mounted() {
    await this.$store.dispatch(Actions.FETCH_COMPONENT_DATA, {
      region: this.getRegion,
      componentId: this.componentId
    });
  },
  unmounted() {
    // when unmount set to instance edit mode
    this.$store.dispatch(Actions.SET_DRAFT_MODE, { status: "no" });
  },
  watch: {
    async instanceId() {
      // when instance id change set to instance edit mode
      this.$store.dispatch(Actions.SET_DRAFT_MODE, { status: "no" });
    },
    draftAndInstance() {
      if (
        this.getInstanceDraft &&
        this.getInstanceDraft.length &&
        this.draftModeStatus === "yes"
      ) {
        const foundItem = this.getInstanceDraft.find((item) => {
          return item.instance_name === this.instanceName;
        });
        if (foundItem && foundItem.attributes) {
          let attributes = foundItem.attributes;
          this.formData = JSON.parse(JSON.stringify(attributes));
        }
      } else if (
        this.getInstanceInfo &&
        this.getInstanceInfo.length &&
        this.draftModeStatus === "no"
      ) {
        const foundItem = this.getInstanceInfo.find((item) => {
          return item.id === this.instanceId;
        });
        if (foundItem && foundItem.attributes) {
          let attributes = foundItem.attributes;
          this.formData = JSON.parse(JSON.stringify(attributes));
        }
      }
    }
  },
  computed: {
    draftAndInstance() {
      const { getInstanceDraft, getInstanceInfo, draftModeStatus } = this;
      return { getInstanceDraft, getInstanceInfo, draftModeStatus };
    },
    instanceData() {
      if (this.getInstanceInfo) {
        return this.getInstanceInfo;
      } else {
        return [];
      }
    },
    draftId() {
      if (this.getInstanceDraft && this.getInstanceDraft.length) {
        const foundItem = this.getInstanceDraft.find((item) => {
          return item.instance_name === this.instanceName;
        });
        return foundItem ? foundItem.id : "";
      } else {
        return "";
      }
    },
    instanceName() {
      if (this.getInstanceInfo && this.getInstanceInfo.length) {
        const foundItem = this.getInstanceInfo.find(
          (item) => item.id === this.$route.params.instanceId
        );
        return foundItem ? foundItem.instance_name : "";
      } else {
        return "";
      }
    },
    componentName() {
      if (this.getAllComponent && this.getAllComponent.length) {
        const foundItem = this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        );
        return foundItem ? foundItem.name : "";
      } else {
        return "";
      }
    },
    ...mapGetters([
      "getAllComponent",
      "getSlideAttribute",
      "getAllAttributes",
      "getInstanceInfo",
      "getInstanceDraft",
      "draftModeStatus",
      "getRegion",
      "currentUser"
    ])
  },
  methods: {
    UpdateInstance() {
      return new Promise((resolve, reject) => {
        let formDataCopy = JSON.parse(JSON.stringify(this.formData));
        this.$store
          .dispatch(Actions.UPDATE_COMPONENT_DATA, {
            formData: formDataCopy,
            region: this.getRegion,
            user: this.currentUser.email,
            currentUrl: window.location.href,
            instanceId: this.instanceId
          })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    CopyInstance() {
      let formDataCopy = JSON.parse(JSON.stringify(this.formData));
      this.$store
        .dispatch(Actions.COPY_COMPONENT_DATA, {
          formData: formDataCopy,
          region: this.getRegion,
          componentId: this.componentId,
          title: this.instanceName.split("|")[1],
          user: this.currentUser.email
        })
        .then(() => {
          this.$router.push({ path: `/component/${this.componentId}` });
        });
    },
    handleUpdateFormData(val) {
      this.formData = val;
    },
    handleUpdateDraft() {
      let formDataCopy = JSON.parse(JSON.stringify(this.formData));
      this.$store
        .dispatch(Actions.UPDATE_DRAFT_INSTANCE, {
          formData: formDataCopy,
          region: this.getRegion,
          draftId: this.draftId,
          user: this.currentUser.email,
          currentUrl: window.location.href
        })
        .then(() => {
          this.$store.dispatch(Actions.FETCH_DRAFT_INFO, {
            region: this.getRegion,
            componentId: this.componentId
          });
        });
    },
    handleCreateDraft() {
      let formDataCopy = JSON.parse(JSON.stringify(this.formData));
      const draftData = {
        attributes: formDataCopy,
        instance_name: this.instanceName.split("|")[1]
      };
      this.$store
        .dispatch(Actions.CREATE_DRAFT_INSTANCE, {
          formData: draftData,
          region: this.getRegion,
          componentId: this.componentId,
          user: this.currentUser.email
        })
        .then(() => {
          this.$store.dispatch(Actions.FETCH_DRAFT_INFO, {
            region: this.getRegion,
            componentId: this.componentId
          });
        });
    }
  }
};
</script>
